import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { Machine } from './Machine.js';

/**
 * Single source of truth for knowledge-queue derivation.
 *
 * Used by:
 *  - LocalTicket.knowledgeQueue resolver (async via dossierNumber lookup)
 *  - vapi-tools.ts:createNewTicket (sync via already-fetched machine.productGroup)
 *  - Case.knowledgeQueue resolver (migrate later; leave Case.ts alone for now)
 */

const HPG: ReadonlySet<string> = new Set([
  'Analyser ASMEC', 'Brinell IND', 'DuraPro', 'Hardness', 'Hardness non-Zwick',
  'Hardness US', 'Hardness UZ', 'Jom iny IND', 'Modernization Hardness UZ',
  'Nanoindenter ASMEC', 'Portable IND', 'Rockwell Comp.', 'Rockwell IND',
  'Rockwell ZET', 'Software ASMEC', 'Special Machine', 'Universal IND',
  'Universal ZET', 'Vickers', 'Vickers IND', 'Vickers ZET', 'VRSC',
]);

const DYN: ReadonlySet<string> = new Set([
  'High Speed Testing Machine UP', 'High Speed Testing Machine UZ', 'LTM UP',
  'Modernization Dynamic UZ', 'UTM Dynamic', 'UTM dynamic non-Zwick',
  'UTM dynamic UP', 'UTM dynamic UP ZRT', 'UTM dynamic UZ', 'Vibrophore',
  'Vibrophore non-Zwick', 'Vibrophore UP', 'Vibrophore UZ',
]);

const AUT: ReadonlySet<string> = new Set(['Automation UP', 'Autom UZ']);

export type KnowledgeQueueCode = 'HPG' | 'DYN' | 'AUT' | 'STA';

export function deriveKnowledgeQueue(productGroup: string | null | undefined): KnowledgeQueueCode {
  if (!productGroup) return 'STA';
  if (HPG.has(productGroup)) return 'HPG';
  if (DYN.has(productGroup)) return 'DYN';
  if (AUT.has(productGroup)) return 'AUT';
  return 'STA';
}

export async function deriveKnowledgeQueueAsync(
  dossierNumber: string | null | undefined,
): Promise<KnowledgeQueueCode | null> {
  if (!dossierNumber) return null;
  const machines = await loadMongoData(Machine, { dossierNumber });
  if (!machines[0]) return null;
  return deriveKnowledgeQueue(machines[0].productGroup);
}
